import React, { useEffect, useState } from "react";
import { Box } from "grommet";
import { HeaderNavigation } from "../../components/Headers/GlobalHeader";
import { StickyFooter } from "../../components/Footers/GlobalFooter";
import { Text } from "grommet";
import { useParams } from "react-router-dom";
import axios from "axios";
import API_URL from "../../config/config";
import HandleAssessmentConfirmation from "../../components/InvitePage/HandleAssessmentConfirmation";

const AssessmentConfirmationPage = () => {
  const [managerDetails, setManagerDetails] = useState(null);
  const [error, setError] = useState(null);
  const { manager_id, user_id, assessment_id } = useParams();

  const getManagerDetails = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/user/assessment_invite_details/${manager_id}/${user_id}/${assessment_id}`,
      );
      setManagerDetails(response.data.manager);
    } catch (error) {
      setError(
        error.response?.data?.message || error.message || "An error occurred.",
      );
    }
  };

  useEffect(() => {
    getManagerDetails();
  }, []);

  return (
    <Box fill="vertical" justify="between">
      {/* Main content container */}
      <Box flex="grow">
        <HeaderNavigation quizStarted={true} />
        <Box
          direction="row"
          justify="between"
          align="center"
          margin={{ horizontal: "large" }}
          pad={{ horizontal: "large" }}
          fill="vertical"
          height={{ min: "medium" }}
        >
          {/* Right side with invite confirmation */}
          <Box align="end" pad={{ left: "medium" }}>
            {managerDetails && (
              <HandleAssessmentConfirmation
                managerName={managerDetails.manager_name}
                user_id={user_id}
                assessment_id={assessment_id}
                manager_id={manager_id}
              />
            )}
            {error && <Text color="status-critical">{error}</Text>}
          </Box>
        </Box>
      </Box>
      <StickyFooter />
    </Box>
  );
};

export default AssessmentConfirmationPage;
